import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LocalStorageService } from '../services/localstorage.service';
import { Observable, catchError, of, tap } from 'rxjs';
import {
  IBaseResponse,
  IPostosBloqueadosDTOResponse,
  
} from './model/I-busca-postos-dto';
import {environment} from "../../environments/environment";
import { CONFIG_URLS_API } from 'src/environments/config-envs';

@Injectable({
  providedIn: 'root'
})
export class VendaArlaService {

  private http = inject(HttpClient);
  private localStorageService = inject(LocalStorageService);
  private userGuid = this.localStorageService.getItem('guid');

  // private listaPostos: IPostosBloqueadosDTOResponse = {
  //   retorno: [
  //     {
  //       codigoPosto: 1,
  //       nomePosto: 'Posto 1',
  //       cidade: 'Cidade 1',
  //       estado: 'Estado 1',
  //       endereco: 'Endereço 1',
  //       vendaArlaPermitida: true,
  //       alterarPermissaoVendaArla: (v: boolean) => {},
  //     },
  //     {
  //       codigoPosto: 2,
  //       nomePosto: 'Posto 2',
  //       cidade: 'Cidade 2',
  //       estado: 'Estado 2',
  //       endereco: 'Endereço 2',
  //       vendaArlaPermitida: false,
  //       alterarPermissaoVendaArla: (v: boolean) => {},
  //     },
  //     {
  //       codigoPosto: 3,
  //       nomePosto: 'Posto 3',
  //       cidade: 'Cidade 3',
  //       estado: 'Estado 3',
  //       endereco: 'Endereço 3',
  //       vendaArlaPermitida: true,
  //       alterarPermissaoVendaArla: (v: boolean) => {},
  //     },


  //   ],
  //   sucesso: true,
  //   mensagens: [],
  
  // };
  
  
  
  public buscarPostos(): Observable<IPostosBloqueadosDTOResponse> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userguid: this.userGuid,
      }),
    };

    //return of(this.listaPostos);

    return this.http.get<IPostosBloqueadosDTOResponse>(environment.host_ctf_service + CONFIG_URLS_API.API_PegarListaPostosAsync,{headers: httpOptions.headers} )
      .pipe(
        tap(),
        catchError(this.handleError<IPostosBloqueadosDTOResponse>('buscarPostos',  {retorno: {}} as IPostosBloqueadosDTOResponse))
      );


    }

  public atualizarPosto(indVendaArla: boolean,  postos: Array<any>): Observable<IBaseResponse> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userguid: this.userGuid,
        indVendaArla: indVendaArla.toString(),
      }),
    };

    console.log('Postos:', postos);
    return this.http.put<IBaseResponse>(
      environment.host_ctf_service + CONFIG_URLS_API.API_LiberarBloquearVendaArlaNoPosto, JSON.stringify({'listaPostos': postos}),
      {headers: httpOptions.headers})
      .pipe(
        tap(),
        catchError(this.handleError<IBaseResponse>('atualizarPosto', {} as IBaseResponse))
      );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      return of(result as T);
    };
  }

}
